import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DomService {
  public document: any = {};
  public window: any = false;
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.document = document;
      this.window = window;
    }
  }
  getElementById(id: string): any {
    return this.document?.getElementById(id);
  }
  getDocumentELm() {
    return this.document;
  }
  getWindowELm() {
    return this.window;
  }
}
